import { Component, OnInit } from '@angular/core';
import { BaseModalComponent } from '../../base-modal.component';
import { ModalService } from '../../../../services/modal/modal.service';
import { Router } from '@angular/router';
@Component({
  selector: 'generic',
  moduleId: module.id,
  templateUrl: './generic.component.html',
})

/**
 * Generic Modal
 *  This is a generic modal that has a title, body and a confirm and/or cancel actions.
 *
 *  Example of modalConfig:
 *  const modalConfig = {
 *      type: ModalType.generic,
 *      title: 'This is a title',
 *      body: 'This is the body of this modal',
 *      actions: {
 *          confirm: {
 *              text: 'Something',
 *              callback: () => {
 *                  this.modalService.deactivate()
 *              }
 *          },
 *          cancel: {
 *              text: 'cancel',
 *              callback: () => {
 *                  this.modalService.deactivate()
 *              }
 *          }
 *      }
 *  }
 *  this.modalService.activate(modalConfig);
 */
export class GenericModalComponent extends BaseModalComponent {
  data;
  userResponse: any = {};

  constructor(protected modalService: ModalService, private router: Router) {
    super(modalService);
  }

  cancel() {
    if (this.data.actions && this.data.actions.cancel.callback) {
      this.data.actions.cancel.callback(this.modalService, this.router);
    }
  }

  confirm() {
    if (this.data.actions && this.data.actions.confirm.callback) {
      this.data.actions.confirm.callback(this.modalService, this.router);
    }
  }
}
